const Instascan = {
  Scanner: require('./scanner'),
  Camera: require('./camera')
};

module.exports = Instascan;



//////////////////
// WEBPACK FOOTER
// ./static/js/instascan/index.js
// module id = 812
// module chunks = 12 16 17